import {useSessionStore} from "@/stores/session";
import Network from "@/common/network";


export const useApiHook = () => {
    const session = useSessionStore();

    const showNetworkError = () => {};
    const showInvalidToken = () => {};

    // 대부분의 경우
    const standard = [
        API_HOOK.invalidSession(async () => {
            showInvalidToken();
            await session.logout();
        }),
        API_HOOK.other(async () => {
        }),
    ];

    return {standard};
};

const API_HOOK = {
    invalidSession: f => ({
        cond: ({data}) => data && data.code === Network.unauthorized.code,
        run: async response => {
            return f && await f(response) || true
        },
    }),
    other: f => ({
        cond: ({data}) => data && data.code !== Network.noError.code,
        run: async response => f && await f(response) || true,
    })
};

export const apiError = async (response, hooks) => {
    const hook = hooks && hooks.find(({cond}) => cond(response));
    // 에러코드일경우 true
    return !!hook && await hook.run(response);
};